<template>
  <v-container>
    <h1>{{ $store.getters.sourceDictionaryName }} / Words</h1>
    <SourcesTable v-on:edit="edit($event)" v-on:create="create"></SourcesTable>
    <SourceDialog v-model="dialog" :model="model"></SourceDialog>
  </v-container>
</template>

<script>
import SourcesTable from '../components/SourcesTable'
import SourceDialog from '../components/SourceDialog'

export default {
  components: { SourceDialog, SourcesTable },
  data () {
    return {
      model: null,
      dialog: false
    }
  },
  methods: {
    create () {
      this.model = null
      this.dialog = true
    },
    edit (model) {
      this.model = model
      this.dialog = true
    }
  }
}
</script>
